import React, { FC, useState, useEffect } from 'react';
import { Button, Dialog } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'react-intl';
import ProTable from 'src/app/common/components/ProTable';

import { useDispatch } from 'react-redux';
import { fetchCampaignList } from '../../../network/campaignCrud';
import { getDefaultDisplayDate } from 'src/app/common/utils';
import { CampaignType } from '../../../types/auto-lead-reassignment-types';

const useStyles = makeStyles()((theme) => ({
  modalButtons: {
    marginTop: '15px',
    marginBottom: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialog: {
    padding: '15px',
  },
  dialogBox: {
    with: '12000px',
  },
  noCourseError: {
    textAlign: 'center',
    color: 'red',
  },
}));

const SearchCampaignsBox: FC<any> = (props) => {
  const dispatch = useDispatch();
  const { campaignFilter, onSelectData, popUpVisible, setPopUpVisible } = props;

  const filterInitData = {
    name: '',
  };

  const { classes } = useStyles();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  // eslint-disable-next-line
  const [formLoading, setFormLoading] = useState<boolean>(false);
  // eslint-disable-next-line
  const [filterData, setFilterData] = useState<{ [key: string]: any }>(filterInitData);
  const [selectedRowsState, setSelectedRows] = useState<any>(null);
  const [displayNoCourseError, setDisplayNoCourseError] = useState<boolean>(false);

  const onCancel = () => {
    setPopUpVisible(false);
  };

  const formatEventData = async (newFilterState?: any) => {
    const newFilter = newFilterState || {};
    const requestParams = {
      ...filterData,
      ...newFilter,
    };

    requestParams.page = requestParams.page;
    setFilterData(requestParams);

    if (requestParams.pageSize) {
      requestParams.limit = requestParams.pageSize;
      delete requestParams.pageSize;
    }

    if (campaignFilter?.campaignType === CampaignType.campaignFrom) {
      if (campaignFilter?.leadDateFrom) {
        requestParams.startDateTo = campaignFilter?.leadDateFrom;
      }
      if (campaignFilter?.leadDateTo) {
        requestParams.endDateFrom = campaignFilter?.leadDateTo;
      }
    }

    if (campaignFilter?.campaignType === CampaignType.campaignTo) {
      requestParams.status = 'active';
      requestParams.isHasDistributionRule = true;
      requestParams.isHasEligibilityRule = true;
    }

    const result = await fetchCampaignList(requestParams, dispatch);
    const res = {
      data: result?.docs || [],
      success: true,
      total: result?.totalDocs || 0,
    };

    return res;
  };

  const fetchData = (newFilterState?: any): Promise<any> => {
    setFormLoading(true);
    setDisplayNoCourseError(false);
    return formatEventData(newFilterState);
  };

  const onImport = () => {
    if (!selectedRowsState) {
      setDisplayNoCourseError(true);
    } else {
      onSelectData(selectedRowsState, campaignFilter?.campaignType);
      setPopUpVisible(false);
      setSelectedRows(null);
      setDisplayNoCourseError(false);
    }
  };
  return (
    <div className="tw-flex tw-self-start tw-w-full">
      <Dialog open={popUpVisible} onClose={onCancel} scroll={'paper'} fullWidth maxWidth="lg">
        <>
          <div className="tw-flex tw-mt-6 tw-ml-6">
            <Button onClick={onCancel} variant="contained">
              {Translation('global.back.btnText')}
            </Button>
          </div>
          <div className="tw-p-6">
            <ProTable
              rowKey="key"
              filterTitle={`${Translation('select.label')} Campaign`}
              headerTitle={''}
              columns={[
                {
                  title: Translation('pulseleads.campaign.common.campaignId'),
                  dataIndex: 'campaignId',
                  hideInSearch: true,
                  render: (data: any) => {
                    return <span>{data}</span>;
                  },
                },
                {
                  title: Translation('pulseleads.campaign.common.name'),
                  dataIndex: 'name',
                  render: (data: any) => {
                    return <span>{data}</span>;
                  },
                },
                {
                  title: Translation('pulseleads.campaign.common.startDate'),
                  dataIndex: 'startDate',
                  hideInSearch: true,
                  render: (data: any) => {
                    return <span>{getDefaultDisplayDate(data) || '-'}</span>;
                  },
                },
                {
                  title: Translation('pulseleads.campaign.common.endDate'),
                  dataIndex: 'endDate',
                  hideInSearch: true,
                  render: (data: any) => {
                    return <span>{getDefaultDisplayDate(data) || '-'}</span>;
                  },
                },
                {
                  title: Translation('pulseleads.campaign.common.marketingOwnerName'),
                  dataIndex: 'marketingOwnerName',
                  hideInSearch: true,
                  render: (data: any) => {
                    return <span>{data}</span>;
                  },
                },
              ]}
              pageSize={10}
              request={(params: any) => {
                return fetchData({
                  ...params,
                  page: params.page + 1,
                });
              }}
              toolBarRender={() => []}
              rowSelection={{
                onChange: (_: any, selectedRows: any) => {
                  const selectCourse = selectedRows && selectedRows[0];

                  if (selectCourse) {
                    setSelectedRows(selectedRows[0]);
                    setDisplayNoCourseError(false);
                  }
                },
                getCheckboxProps: (record: any) => {
                  return {};
                },
                selectItems: [selectedRowsState],
              }}
              singleSelect={true}
            />
          </div>
          {displayNoCourseError && <div className={classes.noCourseError}>Please select a campaign</div>}
          <div className={classes.modalButtons}>
            <span className="tw-ml-6 tw-mr-6">
              <Button onClick={onCancel} variant="contained">
                {Translation('app.button.cancel')}
              </Button>
            </span>

            <Button onClick={onImport} variant="contained" color="secondary">
              {Translation('select.label')}
            </Button>
          </div>
        </>
      </Dialog>
    </div>
  );
};

export default SearchCampaignsBox;
